export default __webpack_public_path__ + "static/media/910.811a4747.png";